import { useParams } from 'next/navigation';
import React from 'react';

import { P } from '~components/Typography';
import { useAccountContext } from '~context/account';
import { usePaywallContext } from '~context/paywall';
import { CheckoutReason } from '~features/annals';
import { NeuronImage } from '~shared/ui/atoms';

import { HeaderButtonContainer, HeaderButtonText } from '../../Header.styles';
import {
	CurrentNeurons,
	StyledAnimatedNumberWithContent,
} from './Neurons.styles';

export const Neurons = () => {
	const { balance, isSuccess } = useAccountContext();
	const { openPaywall } = usePaywallContext();
	const { recipientId: botClientId } = useParams<{ recipientId?: string }>();

	return (
		<HeaderButtonContainer
			hoverable={true}
			onClick={openPaywall({
				checkoutReason: botClientId
					? CheckoutReason.Chat
					: CheckoutReason.ChatList,
				prefer: 'neurons',
				botClientId,
			})}
		>
			<CurrentNeurons>
				{isSuccess && (
					<P size="medium" weight={600}>
						<StyledAnimatedNumberWithContent
							duration={[
								{ delta: 0, duration: 1200 },
								{ delta: 99, duration: 3200 },
								{ delta: 2000, duration: 4800 },
							]}
							animationType="increase"
							contentPulseInterval={200}
							value={balance}
						>
							<NeuronImage />
						</StyledAnimatedNumberWithContent>
					</P>
				)}
			</CurrentNeurons>
			<HeaderButtonText size="medium" weight={500}>
				Neurons
			</HeaderButtonText>
		</HeaderButtonContainer>
	);
};
